import { render, staticRenderFns } from "./KnittingPDF.vue?vue&type=template&id=07ff2f9e&scoped=true&"
import script from "./KnittingPDF.vue?vue&type=script&lang=js&"
export * from "./KnittingPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff2f9e",
  null
  
)

export default component.exports